const value = Object.freeze({
  AdditionalInfo: 0,
  ActualSchoolInfo: 1,
  Documents: 2,
  UsageDocuments: 3,
  StatusHistory: 4,
  LogHistory: 5,
  AppointmentHistory: 6,
});
export default value;
